import { getOrSetDefaultValue } from './utils';
export class DynamicWorkflowDefinitionManager {
    constructor() {
        this.workflowDefByWorkflowAndContextId = new Map();
        this.workflowDefByWorkflow = new Map();
    }
    static mergeDefinitions(defaultDefinition, currentOverride, newOverride) {
        return Object.assign(Object.assign(Object.assign({}, defaultDefinition), currentOverride), newOverride);
    }
    mergeWorkflowDefinition(workflow, workflowDefinition, contextId) {
        if (contextId) {
            const currentDefs = getOrSetDefaultValue(this.workflowDefByWorkflowAndContextId, workflow.id, () => new Map());
            currentDefs.set(contextId, DynamicWorkflowDefinitionManager.mergeDefinitions(workflow, currentDefs.get(contextId), workflowDefinition));
        }
        else {
            this.workflowDefByWorkflow.set(workflow.id, DynamicWorkflowDefinitionManager.mergeDefinitions(workflow, this.workflowDefByWorkflow.get(workflow.id), workflowDefinition));
        }
    }
    getWorkflowDefinition(workflow, contextId) {
        var _a;
        let definition;
        if (contextId) {
            definition = (_a = this.workflowDefByWorkflowAndContextId.get(workflow.id)) === null || _a === void 0 ? void 0 : _a.get(contextId);
        }
        if (!definition) {
            definition = this.workflowDefByWorkflow.get(workflow.id);
        }
        if (!definition) {
            definition = workflow;
        }
        return definition;
    }
    deleteWorkflowDefinition(workflow, contextId) {
        const definitionByContextId = this.workflowDefByWorkflowAndContextId.get(workflow.id);
        if (definitionByContextId) {
            definitionByContextId.delete(contextId);
            if (definitionByContextId.size === 0) {
                this.workflowDefByWorkflowAndContextId.delete(workflow.id);
            }
        }
    }
}
//# sourceMappingURL=dynamic-workflow-definition-manager.js.map